import { Perm } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface CreateHostState {
  hostEmail: string;
  perm: Perm;
}

const formSlice = createGenericFormSlice({
  name: "createHost",
  initialState: {} as SliceState<CreateHostState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createHostReducer = formSlice.reducer;
export default createHostReducer;
